import { breakpoints } from '@bnnvara/breakpoints';
import { globalBorderRadius } from '@bnnvara/themes';
import styled from 'styled-components';
export const Container = styled.div`
  display: grid;
  grid-template-columns: 112px auto;
  background-color: ${({
  theme
}) => theme.base.white};
  border-radius: ${globalBorderRadius};

  ${breakpoints.md} {
    display: block;
  }
`;
export const Text = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding-left: 8px;
  color: ${({
  theme
}) => theme.base.black};

  ${breakpoints.md} {
    display: none;
  }
`;